export default __webpack_public_path__ + "static/media/helo1.a3fe10b1.png";